// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/en'
import router from './router'
import store from './store'
import Utils from './untils'
import  '../static/scss/font.css'
import animated from 'animate.css'
import '../src/assets/icon/iconfont.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import * as VueGoogleMaps from "vue2-google-maps";
import Vue2Filters from 'vue2-filters'
import VueCompositionAPI from '@vue/composition-api'

Vue.use(Vue2Filters)
import VueClipboard from 'vue-clipboard2' //复制
Vue.use(VueClipboard)
Vue.use(VueAwesomeSwiper)
Vue.use(VueCompositionAPI)
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyBy3UZkphCN4GX3unEqN-zLKP358CtlG2s",
    libraries: "places",
  },
});

// 导入echarts
import echarts from 'echarts'
Vue.prototype.$echarts = echarts
Vue.prototype.$box = Utils;

// 富文本编辑框
import VueQuillEditor from 'vue-quill-editor'
// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.use(VueQuillEditor, /* { default global options } */)

Vue.use(ElementUI, { locale })

Vue.use(animated)

Vue.config.productionTip = false
window.Utils = Utils;
import '../static/scss/index.scss'

import '../static/scss/tenant/dashboard-unifiproperty.css';

Vue.http.options.emulateJSON = true;

new Vue({
  el: '#app',
  router,
  store,
  // components: { App },
  template: '<App/>',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js